import { downloadBlob } from "@/components/feature/pdf/helpers";

export type CsvCell = string | number | null;

// Cells starting with these characters run as formulas in spreadsheet apps; names, titles
// and IDs come from documents, imported feeds and model output, so they are neutralised.
const FORMULA_PREFIX = /^[=+\-@\t\r]/;

const csvCell = (value: CsvCell) => {
  if (value === null) return '""';
  const text = typeof value === "number" ? String(value) : value.replace(FORMULA_PREFIX, "'$&");
  return `"${text.replaceAll('"', '""')}"`;
};

export const toCsv = (rows: CsvCell[][]) => rows.map(row => row.map(csvCell).join(",")).join("\r\n");

// Excel reads a CSV without a byte order mark as ANSI and garbles non-ASCII names.
const BYTE_ORDER_MARK = String.fromCharCode(0xfeff);

export const downloadCsv = (csv: string, fileName: string) =>
  downloadBlob(new Blob([BYTE_ORDER_MARK + csv], { type: "text/csv;charset=utf-8" }), fileName);
